<template>
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="initPrint()"
        size="mini"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>
    <div id="needPrint" class="hello">
      <div
        style="width:794px; height: 1123px; margin:auto; border: 4px solid #000; "
      >
        <!-- 标题栏 -->
        <div
          class="title-3"
          style="width:100%;height:70px; border: 1px solid #000;display: flex"
        >
          <div class="bianhao" style="width: 35%;">
            <p class="biaohao-1">{{ bianhao }}</p>
          </div>
          <div
            class="gongdan"
            style="width: 30%;font-size: 42px;font-weight: 2000;text-align: center; line-height: 90px;"
          >
            生产工单
          </div>
          <div class="riqi" style="width: 35%;">
            <p>{{ riqi }}</p>
          </div>
        </div>

        <!-- 主要信息 -->
        <div
          class="mainbox"
          style="height:200px; width:100%;border: 1px solid #000;"
        >
          <div
            style="width: 100%;height:50px; display: flex; border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">产品名称</div>
            <div class="mainbox-value" style="width: 22%;">
              {{ productName }}
            </div>
            <div class="mainbox-item" style="width: 12%;">机台</div>
            <div class="mainbox-value" style="width: 18%;">
              {{ machineNumber }}
            </div>
            <div class="mainbox-item" style="width: 12%;">供应商</div>
            <div class="mainbox-value" style="width: 24%;border-right: 0;">
              {{ customer }}
            </div>
          </div>

          <div
            style="width: 100%;height:50px; display: flex;border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">车速</div>
            <div class="mainbox-value" style="width: 22%;">{{ speed }}</div>
            <div class="mainbox-item" style="width: 12%;">原料编号</div>
            <div class="mainbox-value" style="width: 18%;">
              {{ materialNumber }}
            </div>
            <div class="mainbox-item" style="width: 12%;">原料规格</div>
            <div class="mainbox-value" style="width: 24%;border-right: 0;">
              {{ materialSpec }}
            </div>
          </div>
          <div
            style="width: 100%;height:50px; display: flex;border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">D数</div>
            <div class="mainbox-value" style="width: 22%;">
              {{ dcount }}
            </div>
            <div class="mainbox-item" style="width: 12%;">头纹数</div>
            <div class="mainbox-value" style="width: 18%;">
              {{ headLine }}
            </div>
            <div class="mainbox-item" style="width: 12%;">米数</div>
            <div class="mainbox-value" style="width: 24%; border-right: 0;">
              {{ clothLength }}
            </div>
          </div>

          <div
            style="width: 100%;height:50px; display: flex;border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">圈数</div>
            <div class="mainbox-value" style="width: 22%;">
              {{ turns }}
            </div>
            <div class="mainbox-item" style="width: 12%;">盘头个数</div>
            <div class="mainbox-value" style="width: 18%;">
              {{ gbCount }}
            </div>
            <div class="mainbox-item" style="width: 12%;">盘头尺寸</div>
            <div class="mainbox-value" style="width: 24%; border-right: 0;">
              {{ gbSize }}
            </div>
          </div>
        </div>

        <!-- <div
          style="width: 100%; height: 20px;border: 1px solid #000;margin:auto;"
        ></div> -->

        <!-- 备注 -->
        <div
          style="width: 100%; height: 200px;border: 1px solid #000;margin:auto;"
        >
          <div style="width: 100%; height: 100%;  display: flex;margin:auto;">
            <div
              style="width: 11.8%;padding-left: 5px;font-weight: 800; height: 100%; border-right: 1px solid #000; display: flex; align-items: center;text-align: center;"
            >
              备<br /><br /><br /><br />注
            </div>
            <div
              style="width: 88%; display: flex; align-items: center;  word-break:break-all ;font-weight: 700;"
            >
              {{ remark }}
            </div>
          </div>
        </div>

        <!-- 制单人 -->
        <div
          style="width: 100%; height:50px;margin:auto;border-top: 1px solid #000;"
        >
          <div style="width: 100%;  display: flex;">
            <div
              style="width: 50%; text-align: left;margin-left: 5px;line-height: 50px;font-weight: 700;"
            >
              {{ zhiDanRen }}
            </div>
            <div
              style="width: 50%; text-align: left;margin-left: 5px;line-height: 50px;font-weight: 700;"
            >
              {{ shengHeRen }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "workOrderPrint",
  props: {
    productName: String,
    bianhao: String,
    riqi: String,

    machineNumber: String,
    speed: String,
    clothLength: String,
    creator: String,
    clothLength: String,
    department: String,
    customer: String,
    dcount: String,
    gbCount: String,
    gbPerimeter: String,
    gbSize: String,
    headLine: String,
    materialNumber: String,
    materialSpec: String,
    temperature: String,
    turns: String,

    remark: String,
    zhiDanRen: String,
    shengHeRen: String,
  },
  data() {
    console.log("打印工单");
    return {
      title: "打印工单",
    };
  },
  created() {
    var workOrderInfo = this.$route.query.data;
    this.initdata(workOrderInfo);
    console.log(workOrderInfo);
  },
  mounted() {
    this.initPrint();
    this.autoClose();
  },

  methods: {
    autoClose: function() {
      var currentView = this.$store.state.tagsView.visitedViews[0];
      for (currentView of this.$store.state.tagsView.visitedViews) {
        if (currentView.path === this.$route.path) {
          break;
        }
      }
      this.$store
        .dispatch("tagsView/delView", currentView)
        .then(({ visitedViews }) => {
          if (currentView.path === this.$route.path) {
            const latestView = this.$store.state.tagsView.visitedViews.slice(
              -1
            )[0];
            if (latestView) {
              this.$router.push(latestView);
            } else {
              // 如果没有其他标签则跳转到首页
              if (currentView.name === "首页") {
                this.$router.replace({
                  path: "/redirect" + currentView.fullPath,
                });
              } else {
                this.$router.push("/");
              }
            }
          }
        });
    },
    initdata: function(info) {
      try {
        console.log(this.$route.query.data);
        const workOrder = this.$route.query.data;
        if (workOrder == null) return;

        this.productName = workOrder.productName;
        this.bianhao = "编号：" + workOrder.number;
        this.riqi = workOrder.createTime;

        this.machineNumber = workOrder.machineNumber;
        this.creator = workOrder.creator;
        this.clothLength = workOrder.clothLength + "米";
        this.department = workOrder.department;
        this.customer = workOrder.customer;
        this.dcount = workOrder.dcount + "D";
        this.gbCount = workOrder.gbCount + "个";
        this.gbPerimeter = workOrder.gbPerimeter;
        this.gbSize = parseInt(workOrder.gbSize) / 100 + "英寸";
        this.headLine = workOrder.headLine + "条";
        this.materialNumber = workOrder.materialNumber;
        this.materialSpec = workOrder.materialSpec;
        this.temperature = workOrder.temperature + "度";
        this.turns = workOrder.turns + "圈";
        this.speed = parseInt(workOrder.speed) / 100 + " 转/分钟";

        this.remark = workOrder.remark;
        this.zhiDanRen = "制单人：";
        this.shengHeRen = "审核人：";
      } catch (e) {
        console.log(e);
      }
    },

    // 在打印当前报表前，拼接title
    initPrint() {
      let style = `
		* {
			margin: 0;
			padding: 0;
			font-size: 20px;
			font-weight: 500;
			font-family:'Microsoft YaHei';
			/* line-height: 40px; */
			}

			.mainbox-item{
				line-height:50px;
				text-align: left;
				padding-left: 5px;
				padding-right: 5px;
				border-right:1px solid #000;
				font-weight: 800;
				display: inline-block;

				text-align: justify;
				text-align-last:justify;
				text-justify: distribute-all-lines;/*这行必加，兼容ie浏览器*/
			}
			.mainbox-value{
				line-height:50px;
				text-align: left;
				padding-left: 5px;
				border-right:1px solid #000;
				font-size: 20px;
        font-weight: 600;
			}
			.yuanliao-item{
				padding-left: 5px;
				border-right:1px solid #000;
				text-align: left;
				line-height:50px;
				font-weight: 800;
        
			}
			.yuanliao-value{
				padding-left: 5px;
				border-right:1px solid #000;
				text-align: center;
				line-height:50px;
			}
			.riqi{
				height: 100% !important;
				position: relative;
				margin-right: 5px;
			}
			.riqi p{
				position: absolute;
				bottom: 5px;
				text-align: right;
				width:100%;
			}
			.bianhao{
				height: 100% !important;
				position: relative;
				margin-left: 5px;
			}
			.bianhao p{
				position: absolute;
				bottom: 5px;
				width:100%;
			}

		`;
      this.utils.printElement("needPrint", `工单详情`, style);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 500;
  font-family: "Microsoft YaHei";
  /* line-height: 40px; */
}
/* .demo {
} */
.mainbox-item {
  line-height: 50px;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  border-right: 1px solid #000;
  font-weight: 800;
  display: inline-block;

  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines; /*这行必加，兼容ie浏览器*/
}
.mainbox-value {
  line-height: 50px;
  text-align: left;
  padding-left: 5px;
  border-right: 1px solid #000;
  font-size: 18px;
}
.yuanliao-item {
  padding-left: 5px;
  border-right: 1px solid #000;
  text-align: left;
  line-height: 50px;
  font-weight: 800;
}
.yuanliao-value {
  padding-left: 5px;
  border-right: 1px solid #000;
  text-align: center;
  line-height: 50px;
}
.riqi {
  height: 100% !important;
  position: relative;
  margin-right: 5px;
}
.riqi p {
  position: absolute;
  bottom: 5px;
  text-align: right;
  width: 100%;
}
.bianhao {
  height: 100% !important;
  position: relative;
  margin-left: 5px;
}
.bianhao p {
  position: absolute;
  bottom: 5px;
  width: 100%;
}
</style>
